import React from 'react';
import styled from 'styled-components';
import 'react-circular-progressbar/dist/styles.css';
import { BasicGauge } from './BasicGauge';

const CustomToolTipStyle = styled.div`
	width: 90px;
	height: 250px;
	border: 1px solid #ffffff;
	border-radius: 44px;
	overflow: hidden;
	.top-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 95px;
		background-color: #ffffff;
		opacity: 0.7;
	}
	.top-info {
		margin-top: 10px;
		display: flex;
	}
	.bottom-info {
		margin-top: 30px;
	}
	.element {
		width: 100%;
		height: 78px;
		border-bottom: 1px solid #ffffff;
	}
`;

export const CustomToolTip = ({
	id,
	cypressId,
	value1,
	value2,
	value3,
	value2Label,
	value3Label,
	unit,
	bottomText,
}) => {
	return (
		<CustomToolTipStyle id={id} data-cy={cypressId} className='custom-tooltip'>
			<div className='top-section'>
				<div className='top-info'>
					<div className='value numbers20'>{value1}</div>
					<div className='unit body10'>{unit}</div>
				</div>
				<div className='bottom-info body10'>{bottomText}</div>
			</div>
			<div className='element'>
				<BasicGauge
					id='gauge-1'
					width={'60px'}
					height={'60px'}
					value={value2}
					percent={((value2 / value1) * 100) / 1}
					unit={unit}
					label={value2Label}
				/>
			</div>
			<div className='element'>
				<BasicGauge
					id='gauge-2'
					width={'60px'}
					height={'60px'}
					value={value3}
					percent={((value3 / value1) * 100) / 1}
					unit={unit}
					label={value3Label}
				/>
			</div>
		</CustomToolTipStyle>
	);
};
